export default __webpack_public_path__ + "static/media/accelerator-bg-1920.263580f7.jpg";